var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"game-loading",staticClass:"game-loading"},[_vm._m(0),_c('div',{staticClass:"game_tip"},[_vm._v("可通过方向键上下左右控制移动方向")]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Start_game"}},[_c('p',[_vm._v("等待期间不妨按下【空格键】，放松一下呀～")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map"}},[_c('div',{attrs:{"id":"Snak_head"}})])
}]

export { render, staticRenderFns }